import React, { Component } from "react";
import {
  InputGroup,
  InputGroupAddon,
  Input,
  Row,
  Col,
  Button,
  Table
} from "reactstrap";
import { reduxForm } from 'redux-form'
import { connect } from 'react-redux';
import Collapsible from 'react-collapsible';
import BlockUi from 'react-block-ui';
import Pagination from "react-js-pagination";
import * as nhaCungCapConstant from './constants'
import * as nhaCungCapAction from './actions'
import { storedb } from '../../views/client/storedb'
import DisplayRecordText from "../controls/_DisplayRecordText"
import { BtnPermissions, BtnType } from '../../lib/BtnPermissions';
import { ButtonExt } from "../controls/ButtonExt"
import { confirmAlert } from 'react-confirm-alert';
import Messages from '../../notifications/Messages'
import Errors from '../../notifications/Errors'

class NhaCungCap extends Component {
  constructor(props) {
    super(props);
    var dbContext = storedb();
    this.state = {
      stores_id: dbContext.getStoreId(),
      item: {},
      list: [],
      keyword: '',
      per_page: 20,
      page: 1,
      total_record: 0
    };
  }
  handlePageChange = (pageNumber) => {
    let page = parseInt(pageNumber || 1)
    return this.setState({ page }, this.fetchList);
  }
  handleSearchChange = (name, e, value) => {
    switch (name) {
      case "keyword":
        this.setState({ keyword: e.target.value });
        break;
      default:
        break;
    }
  }
  fetchList = () => {
    const { nhaCungCapListRequest } = this.props
    var requestData = {
      stores_id: this.state.stores_id,
      keyword: this.state.keyword,
      page: this.state.page,
      per_page: this.state.per_page
    };
    return nhaCungCapListRequest(requestData);
  }
  search = () => {
    if (this.props.nhaCungCap.listRequesting) {
      return false;
    }
    return this.fetchList()
  }
  refresh = () => {
    this.setState({
      stores_id: this.state.stores_id,
      keyword: '',
      page: this.state.page,
      per_page: this.state.per_page
    }, () => {
      if (this.props.nhaCungCap.listRequesting) {
        return false;
      }
      return this.fetchList()
    })
  }
  onChangeItem = (itemPerPage) => {
    this.setState({ per_page: itemPerPage }, () => {
      this.search();
    });
  }
  EditNhaCungCapItem = (item, e) => {
    this.props.history.push('/nhacungcap-edit?ncc=' + (item.NhaCCId || ""));
  }
  processRemoveClick = (item) => {
    if (!item.NhaCCId && item.NhaCCId <= 0) {
      return;
    }
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            <h1>THÔNG BÁO?</h1>
            <p>Bạn chắc chắn muốn xóa nhà cung cấp <b className="text-danger">{item.Ten}</b> không?</p>
            <button className="text-danger" onClick={() => {
              this.processRemoveItem(item)
              onClose()
            }}>Đồng ý</button>
            <button onClick={onClose}>Hủy bỏ</button>
          </div>
        )
      }
    });
  }
  processRemoveItem = (item) => {
    var requestData = {
      StoreId: this.state.stores_id,
      NhaCCId: item.NhaCCId,
    }
    return this.props.nhaCungCapRemoveRequest(requestData, () => {
      this.fetchList()
    });
  }
  componentDidMount() {
    this.fetchList();
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.nhaCungCap.type == nhaCungCapConstant.NHACUNGCAP_LIST_SUCCESS) {
      let { list, item } = nextProps.nhaCungCap;
      this.setState({
        page: item.page,
        per_page: item.per_page,
        total_record: item.total_record,
        list: list
      });
    }
  }
  render() {
    const {
      handleSubmit,
      nhaCungCap: {
        listRequesting,
        list,
        isRequesting,
        errors,
        messages
      },
    } = this.props
    return (
      <div className="animated fadeIn">
        <BlockUi tag="div" blocking={listRequesting} >
          <div>
            <Collapsible trigger="Tìm kiếm..." open={true}>
              <Row>
                <Col sm="12" className="mb-2">
                  <InputGroup size="md">
                    <InputGroupAddon addonType="prepend" autoComplete="off" >Thông tin nhà cung cấp</InputGroupAddon>
                    <Input name="keyword" placeholder="Tên, mã, địa chỉ, email, điện thoại" value={this.state.keyword} onChange={this.handleSearchChange.bind(this, "keyword")} />
                  </InputGroup>
                </Col>
              </Row>
            </Collapsible>
          </div>
          <div className="mt-2 bg-white">
            <div className="w-100 mb-2">
              <Button size="md" color="success" className="pull-left mr-1"
                onClick={handleSubmit(this.search)}><i className="fa fa-search"></i> Tìm kiếm</Button>
              <ButtonExt className="mr-1"
                color="primary"
                iconClass="fa-plus"
                displayText="Thêm mới"
                btnClick={() => this.EditNhaCungCapItem({})}
                permission={BtnPermissions.NhaCungCap.ADD_OR_UPDATE} />
            </div>
            <div className="w-100">
              <Row>
                <Col md="12">
                  {!isRequesting && !!errors.length && (
                    <Errors errors={errors} />
                  )}
                  {!isRequesting && !!messages.length && (
                    <Messages messages={messages} />
                  )}
                </Col>
              </Row>
              <DisplayRecordText
                itemsCountPerPage={this.state.per_page}
                onChangeItem={this.onChangeItem}
              />
              <Table hover responsive className="table-outline mb-0 d-sm-table table-sm">
                <thead className="thead-default">
                  <tr>
                    <th scope="col" width="50" className="text-center">#</th>
                    <th scope="col" width="120" className="text-left">Mã NCC</th>
                    <th scope="col" className="text-left">Tên nhà cung cấp</th>
                    <th scope="col" width="120" className="text-left">Điện thoại</th>
                    <th scope="col" className="text-left">Địa chỉ</th>
                    <th scope="col" width="120" className="text-center">Email</th>
                    <th scope="col" width="50" className="text-center">Sửa</th>
                    <th scope="col" width="30" className="text-center">Xóa</th>
                  </tr>
                </thead>
                <tbody>
                  {list && !!list.length && (
                    list.map((res, idx) => (
                      <tr key={idx + 1}>
                        <td className="text-center">{idx + 1}</td>
                        <td className="text-left">{res.Ma}</td>
                        <td className="text-left">{res.Ten}</td>
                        <td className="text-left">{res.DienThoai}</td>
                        <td className="text-left">{res.DiaChi}</td>
                        <td className="text-center">{res.Email}</td>
                        <td scope="row" className="text-center">
                          <ButtonExt
                            btnClass="text-primary"
                            iconClass="fa-edit fa-lg"
                            btnType={BtnType.ButtonLink}
                            btnClick={() => this.EditNhaCungCapItem(res)}
                            permission={BtnPermissions.NhaCungCap.ADD_OR_UPDATE} />
                        </td>
                        <td scope="row" className="text-center">
                          <ButtonExt
                            btnClass="text-danger"
                            iconClass="fa-trash fa-lg"
                            btnType={BtnType.ButtonLink}
                            btnClick={() => this.processRemoveClick(res)}
                            permission={BtnPermissions.NhaCungCap.REMOVE} />
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>
              {this.state.total_record > this.state.per_page && (
                <Pagination
                  activePage={this.state.page}
                  itemsCountPerPage={this.state.per_page}
                  totalItemsCount={this.state.total_record}
                  pageRangeDisplayed={5}
                  onChange={this.handlePageChange}
                />
              )}
            </div>
            <div className="clearfix"></div>
          </div>
        </BlockUi>
      </div>
    )
  }
}
const mapStateToProps = state => ({
  nhaCungCap: state.nhaCungCap,
  client: state.client,
})
const connected = connect(mapStateToProps, {
  nhaCungCapListRequest: nhaCungCapAction.nhaCungCapListRequest,
  nhaCungCapUpdateRequest: nhaCungCapAction.nhaCungCapUpdateRequest,
  nhaCungCapRemoveRequest: nhaCungCapAction.nhaCungCapRemoveRequest
})(NhaCungCap)
const formed = reduxForm({
  form: 'nhaCungCap',
})(connected)
export default formed;



// WEBPACK FOOTER //
// ./src/views/NhaCC/NhaCC.js